export default __webpack_public_path__ + "static/media/manageCodebase.96fa8592.png";